/**
 * An answer card: one question and two to four options, formulas typeset, answered with one tap so a
 * formula never has to be typed. Plain .ts so `node --test` can load it.
 */

export type AnswerArgs = { ok: true; question: string; options: string[]; allowOwn: boolean } | { ok: false; error: string };

export interface AnswerResult {
	/** The option's place, from 0; null when they wrote their own. */
	choice: number | null;
	picked: string | null;
	own: string | null;
}

export function parseAnswerArgs(args: Record<string, unknown>): AnswerArgs {
	const question = typeof args.question === "string" ? args.question.trim() : "";
	if (!question) return { ok: false, error: "答题卡缺少题目" };
	const options = args.options;
	if (!Array.isArray(options) || options.length < 2 || options.length > 4 || !options.every((o) => typeof o === "string" && o.trim())) {
		return { ok: false, error: "答题卡选项无法读取" };
	}
	return { ok: true, question, options: options as string[], allowOwn: args.allowOwn !== false };
}

export function shapeAnswer(options: readonly string[], answer: { pick: number } | { own: string }): AnswerResult {
	if ("pick" in answer) return { choice: answer.pick, picked: options[answer.pick] ?? null, own: null };
	return { choice: null, picked: null, own: answer.own.trim() };
}

/** Which option an answered card shows as picked, or null. */
export function answeredPick(value: Record<string, unknown>): number | null {
	return typeof value.choice === "number" ? value.choice : null;
}
